import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import HeaderDesktop from '../../components/header/HeaderDesktop';
import HeaderMobile from '../../components/header/HeaderMobile';
import BottomBar from '../../components/bottomBar/BottomBar';
import Footer from '../../components/footer/footer';

const Layout = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className="flex flex-col min-h-screen justify-between items-center w-full h-full bg-white overflow-y-auto">
      {/* Header Desktop o Mobile */}
      {isMobile ? <HeaderMobile /> : <HeaderDesktop />}

      {/* Contenuto principale con flex-grow per riempire lo spazio disponibile */}
      <main className="w-full flex flex-col items-center justify-center flex-grow bg-smoky px-2 lg:px-10 md:px-2">
        <Outlet /> 
      </main>

      {/* Footer sempre alla fine */}
      <Footer />

      {/* Bottom Bar per dispositivi mobili */}
      {isMobile && <BottomBar />}
    </div>
  );
};

export default Layout;
